/**
 * 获取文案的宽度，用于判断是否需要换行
 * @param text 文案内容
 * @param newStyle 文案样式
 */
export function getTextSize(text, newStyle = {}) {
  try {
    // 新增一个标签
    let span = document.getElementById('__calc_text_width__');
    const positionStyle = 'opacity:0; position:absolute; right:-99999px; top:-99999px;';
    if (!span) {
      span = document.createElement('span');
      span.id = '__calc_text_width__';
      span.style.cssText = positionStyle;
      document.body.appendChild(span);
    }

    // 补充新样式
    const styleKeys = Object.keys(newStyle) || [];
    if (styleKeys.length > 0) {
      let newStyleStr = positionStyle;
      styleKeys.forEach(key => {
        newStyleStr += `${key}:${newStyle[key]}; `;
      });
      span.style.cssText = newStyleStr;
    }

    // 设置最新文案
    if (typeof span.textContent !== 'undefined') {
      span.textContent = text;
    } else {
      span.innerText = text;
    }

    // 返回文案宽度
    return span.getClientRects()[0];
  } catch (error) {
    return {
      width: 0,
      height: 0,
      error,
    };
  }
}
